import Link from 'next/link';
import { useRouter } from 'next/router';
import { useUser } from '@/contexts/AuthContext';
import { themeLight } from '@/themes/light';
import { ROUTER_PAGES } from '@/utils/constants';
import { isAuthenticatedOrFirstAccessPage } from '@/utils/validates';
import { Help, HelpOutline } from '@mui/icons-material';
import { IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';

export default function IconHelp() {
  const router = useRouter();
  const mdUp = useMediaQuery(themeLight.breakpoints.up('md'));
  const { isAuthenticated } = useUser();

  const helpHref = `${ROUTER_PAGES.ajuda}/cotacoes/como-responder-cotacoes`;

  const isAuthenticatedOrFirstAccess = isAuthenticatedOrFirstAccessPage(
    isAuthenticated,
    router
  );

  return (
    <Tooltip title="Dúvidas frequentes" placement="left" arrow>
      <Link href={helpHref} passHref>
        <IconButton
          aria-label="redirect-to-help"
          component="a"
          target="_blank"
          edge="start"
          sx={{
            color: isAuthenticatedOrFirstAccess
              ? 'background.paper'
              : 'primary.main',
          }}
        >
          {mdUp ? (
            <Typography fontWeight={isAuthenticated ? 'bold' : 'normal'}>
              Ajuda?
            </Typography>
          ) : isAuthenticated ? (
            <HelpOutline />
          ) : (
            <Help />
          )}
        </IconButton>
      </Link>
    </Tooltip>
  );
}
